import React from 'react';
import styles from './styles.css';

const Heading = ({ text, children }) => (
  <>
    <h1 data-name="HeadingTitle">
      {text}
      {children}
    </h1>
    <style jsx>{styles}</style>
  </>
);

Heading.defaultProps = {
  text: ''
};

export default Heading;
